import React, { useEffect, useState } from "react";

import Typography from "@mui/material/Typography";
import "./Login.scss";
import "react-toastify/dist/ReactToastify.css";
import signin from "../../Img/ph-img-signin.svg";
import { useMediaQuery, useTheme,Grid } from "@mui/material";
import Darkmode from "../DarkMode/Darkmode";
import lightlogo from "../../Img/light-mode-logo.png";
import darkLogo from "../../Img/reglogo.png";
import { Link } from "react-router-dom";
import { ThemeContext } from "../DarkMode/ThemeProvider";
import { useContext } from "react";
import { NavLink,useNavigate } from "react-router-dom";
import newloginLogo from '../../Img/newlogin-bg.png'


export default function AuthLeft() {
const navigate = useNavigate()
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const { isLightMode, handleDarkmode } = useContext(ThemeContext);
  return (
    <>

    <div className="auth-left-full" style={md ? {height:"auto"} :{height:"100%"}}>
      
<div  onClick={(()=>{navigate('/')}) } className='cursor leftAuth'>
  <img src={newloginLogo} alt="newloginLogo" />
</div>
      </div>
    </>
  );
}
